import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=2a12c7c8&scoped=true"
import script from "./Address.vue?vue&type=script&setup=true&lang=js"
export * from "./Address.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Address.vue?vue&type=style&index=0&id=2a12c7c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a12c7c8",
  null
  
)

export default component.exports